var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-index container"},[_c('h1',{staticClass:"nav-title"},[_vm._v(_vm._s(_vm.$t("nav.news")))]),_c('cpo-news-list',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }